import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import { reduxForm } from 'redux-form';
import Loader from '../../../../common/Loader';
import FormFooter from '../../../../common/forms/FormFooter';
import { getYangoDelivery, clearYangoDelivery } from '../../../../../actions';

export const YangoDeliveryForm = ({
  handleSubmit,
  deliveryId,
  loading,
  yangoDeliveryPrice,
  dispatchGetYangoDelivery,
  dispatchClearYangoDelivery,
}) => {
  useLayoutEffect(() => {
    dispatchGetYangoDelivery({ deliveryId });

    return () => dispatchClearYangoDelivery();
  }, [deliveryId]);

  if (!yangoDeliveryPrice || yangoDeliveryPrice.isEmpty()) {
    return <Loader />;
  } else if (loading) {
    return <Loader />;
  }

  const yangoDeliveryPriceJs = yangoDeliveryPrice.toJS();

  return (
    <>
      <h2>Cotización de Reparto de Yango</h2>
      <Form onSubmit={handleSubmit}>
        {yangoDeliveryPriceJs.cargoDeliveryLastMille.cargoDeliveryPointList
          .slice(1)
          .map((point, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index}>
              <strong>
                Dirección: {point.address} ({index + 1})
              </strong>
            </li>
          ))}
        <div className="mb-3">
          <h4>Precio de Entrega</h4>
          <p>
            El precio estimado para la entrega es:{' '}
            <strong>S/ {yangoDeliveryPrice.get('price')}</strong>
          </p>
        </div>
        <FormFooter
          saveButtonText="COMENZAR BÚSQUEDA DE REPARTIDOR"
          saveButtonDisabled={loading}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-search'}
        />
      </Form>
    </>
  );
};

YangoDeliveryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  deliveryId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  yangoDeliveryPrice: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchGetYangoDelivery: PropTypes.func.isRequired,
  dispatchClearYangoDelivery: PropTypes.func.isRequired,
};

YangoDeliveryForm.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ CargoUnit }) => ({
  loading: !CargoUnit.Delivery.getIn(['yango', 'activity']).isEmpty(),
  yangoDeliveryPrice: CargoUnit.Delivery.getIn(
    ['yango', 'price'],
    Immutable.Map(),
  ),
});

const mapDispatchToProps = {
  dispatchGetYangoDelivery: getYangoDelivery,
  dispatchClearYangoDelivery: clearYangoDelivery,
};

const formComponent = reduxForm({
  form: 'YangoDeliveryForm',
})(YangoDeliveryForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
